import React, { useState, useEffect, Fragment } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import Host from "../../Components/Host";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import HelmetComponent from "../../Components/HelmetComponent";

function AboutUs() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  return (
    <>
      <HelmetComponent title={"About Us"} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div
                className="static-container-card"
                style={{
                  textAlign: "left",
                  padding: "20px",
                  background: "#fcfcfc",
                  border: "1px solid #eee",
                  borderRadius: "7px",
                }}
              >
                <h1 style={{ padding: "20px 0px 20px 0px", fontWeight: 300, fontSize: "1.4rem" }}>
                  Welcome to Luxura Cart
                </h1>

                <p>
                  In today’s fast-paced world of e-commerce, where almost everything is just a click away,
                  <strong>Luxura Cart</strong> sits at the intersection of global access and trusted curation.
                </p>

                <p>We’re here to make international shopping feel simple, safe, and surprisingly effortless.</p>

                <h4>What We Do</h4>

                <p>
                  At Luxura Cart, our mission is clear: to give customers in UAE easy access to high-quality,
                  authentic products from abroad – without the usual confusion, delays, or hidden costs.
                </p>

                <p>We focus on:</p>
                <ul>
                  <li>High-quality, original products sourced from trusted industry experts around the world</li>
                  <li>Smooth, hassle-free ordering with clear expectations on pricing and timelines</li>
                  <li>Timely delivery, with every step designed to feel seamless for you</li>
                </ul>

                <p>
                  We believe exceptional service and value should not come at an inflated price. Our aim is to delight
                  you, not overcharge you.
                </p>

                <h4>UAE-Based. Global Minded.</h4>

                <ul>
                  <li>Luxura Ventures LLC is a registered company in UAE</li>
                  <li>We specialize in sourcing curated products from all over the world</li>
                  <li>We deliver them to customers across UAE through a simple and reliable online platform</li>
                </ul>

                <p>
                  This means you can purchase hard-to-find or not-typically-available products in the UAE market,
                  without juggling freight forwarders, customs forms, or foreign websites.
                </p>

                <p class="highlight">“Your Click Is My Command” – you place the order, we handle the rest.</p>

                <h4>How We Work</h4>

                <p>To bring you the best possible selection and pricing, we collaborate with:</p>
                <ul>
                  <li>Trusted fulfilment service providers in UAE and the U.S.</li>
                  <li>Verified resellers and sourcing partners</li>
                  <li>Logistics and shipping networks that help us optimise speed and cost</li>
                </ul>

                <p>Our focus is always on:</p>
                <ul>
                  <li>Authenticity – only genuine products</li>
                  <li>Competitive pricing – leveraging our network to get you great value</li>
                  <li>Operational reliability – so your experience feels smooth end to end</li>
                </ul>

                <p>
                  <strong>Please note:</strong>
                </p>
                <ul>
                  <li>
                    In most cases, we do not maintain direct relationships with the brands featured on our site, unless
                    specifically mentioned.
                  </li>
                  <li>
                    Our role is to curate, source, and deliver – acting as your bridge between global products and your
                    doorstep in UAE.
                  </li>
                </ul>

                <h4>Customer Support & Contact</h4>

                <p>Our customer service centre is based in UAE, and we’re always happy to help with:</p>
                <ul>
                  <li>Order-related queries</li>
                  <li>Product information</li>
                  <li>Shipping and tracking support</li>
                  <li>General assistance before or after purchase</li>
                </ul>

                <div class="contact">
                  <p>
                    <strong>You can reach us at:</strong>
                  </p>
                  <ul>
                    <li>
                      Email: <a href="mailto:support@luxuracart.com">support@luxuracart.com</a>
                    </li> 
                  </ul>

                  <p>
                    <strong>Registered Office Address:</strong>
                  </p>

                  <div style={{ lineHeight: 2 }}>
                    <p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: Host?.address,
                        }}
                      ></div>
                      <MailOutlineIcon style={{ fontSize: "1.1rem", color: "#444" }} />
                      &nbsp; {Host?.email} <br />
                    </p>
                  </div>

                  
                </div>

                <p>We’re here to make your global shopping experience feel local, safe, and effortless.</p>

                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
